<template>
  <section class="page-section" v-loading="pageLoading">
        <el-form size="small" label-width="0px" class="content-form">
          <!-- 账户信息 -->
          <div class="form-module no-margin-top">
            <div class="module-header">基本信息</div>
            <div class="module-body clearfix">
              <div class="info">
                <div class="flex-h">
                  <div>
                    <span class="text">ID：</span>
                  </div>
                  <div>
                    <span class="text">{{ detail.id }}</span>
                  </div>
                </div>
                <div class="flex-h">
                  <div>
                    <span class="text">代理姓名：</span>
                  </div>
                  <div>
                    <span class="text">{{ detail.name }}</span>
                  </div>
                  <div style="margin-left: 40px">
                    <span class="text">服务代理等级：</span>
                  </div>
                  <div>
                    <span class="text">{{ detail.serviceLevel }}</span>
                  </div>
                  <div style="margin-left: 40px">
                    <span class="text">商品代理等级：</span>
                  </div>
                  <div>
                    <span class="text">{{ detail.productLevel }}</span>
                  </div>
                </div>
                <div class="flex-h">
                  <div>
                    <span class="text">手机号：</span>
                  </div>
                  <div>
                    <span class="text">{{ detail.mobile }}</span>
                  </div>
                </div>
                <div class="flex-h">
                  <div>
                    <span class="text">添加时间：</span>
                  </div>
                  <div>
                    <span class="text">{{ COMMON.formatDate('2', '-', detail.createDate) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- tabs -->
          <el-tabs v-model="tabName" type="card" @tab-click="handleTabsChange" style="margin-top: 20px">
            <el-tab-pane label="分销收益" name="1"></el-tab-pane>
            <el-tab-pane label="下级顾客排行" name="2"></el-tab-pane>
            <el-tab-pane label="提现记录" name="3"></el-tab-pane>
          </el-tabs>
          <!-- tab list -->
          <div class="form-module">
            <div class="module-body">
              <!-- table -->
              <div class="table-region" v-loading="tableLoading">
                <template v-if="tabName == '1'">
                  <!-- 分销收益 -->
                  <div class="statistics">
                    <span class="item">可提现：￥{{ statistics.validBalance || 0 }}</span>
                    <span class="item">冻结中：￥{{ statistics.frozenBalance || 0 }}</span>
                    <span class="item">已提现：￥{{ (statistics.withdrawBalance || 0) }}</span>
                  </div>
                  <!-- sub tabs -->
                  <el-tabs v-model="subTabName" type="card" @tab-click="handleTabsChange" style="margin-top: 10px">
                    <el-tab-pane label="服务订单" name="1"></el-tab-pane>
                    <el-tab-pane label="商品订单" name="2"></el-tab-pane>
                  </el-tabs>
                  <template v-if="subTabName == '1'">
                    <!-- 增加分销收益 -->
                    <el-button type="primary" size="small" style="margin-top: 10px"
                      @click="handleAddServiceDialogShow">增加分销收益</el-button>
                    <!-- 服务订单统计 -->
                    <div class="statistics default" style="margin-top: 10px">
                      <span class="item">服务订单总金额：￥{{ statistics.serviceOrderAmount || 0 }}</span>
                      <span class="item">服务订单总笔数：{{ statistics.serviceOrderNum || 0 }}</span>
                      <span class="item">服务订单总收益：￥{{ (statistics.serviceOrderIncome || 0) }}</span>
                    </div>
                  </template>
                  <template v-if="subTabName == '2'">
                    <!-- 商品订单统计 -->
                    <div class="statistics default" style="margin-top: 10px">
                      <span class="item">商品订单总金额：￥{{ statistics.productOrderAmount || 0 }}</span>
                      <span class="item">商品订单总笔数：{{ statistics.productOrderNum || 0 }}</span>
                      <span class="item">商品订单总收益：￥{{ (statistics.productOrderIncome || 0) }}</span>
                    </div>
                  </template>
                  <!-- 订单列表 -->
                  <el-table size="small" :data="tableData" style="margin-top: 20px">
                    <el-table-column label="发放收益">
                      <template slot-scope="scope">
                        <p>+{{ scope.row.income }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="发放时间">
                      <template slot-scope="scope">
                        <p>{{ COMMON.formatDate('2', '-', scope.row.incomeTime) }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column :label="subTabName == '1' ? '项目' : '商品'">
                      <template slot-scope="scope">
                        <p style="white-space: pre-line">{{ scope.row.item }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="订单号">
                      <template slot-scope="scope">
                        <p>{{ scope.row.orderNumber }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="订单金额">
                      <template slot-scope="scope">
                        <p>{{ scope.row.orderAmount }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="订单成交时间">
                      <template slot-scope="scope">
                        <p>{{ COMMON.formatDate('2', '-', scope.row.orderCompletionTime) }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="下级顾客">
                      <template slot-scope="scope">
                        <p>{{ scope.row.subCustomer }}<template v-if="scope.row.subCustomerMobile">({{
                          scope.row.subCustomerMobile }})</template>
                        </p>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="subTabName == '1'" label="订单凭证">
                      <template slot-scope="scope">
                        <template v-if="scope.row.orderVoucherImages && scope.row.orderVoucherImages.length > 0">
                          <el-image style="width: 48px; height: 48px; cursor: pointer;"
                            :src="scope.row.orderVoucherImages[0]" :preview-src-list="scope.row.orderVoucherImages"
                            fit="cover">
                          </el-image>
                        </template>
                        <span v-else style="color: #999;">-</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="right">
                      <template slot-scope="scope">
                        <el-popover placement="left" width="160" v-model="scope.row.deleteVisible"
                          popper-class="confirm-popover">
                          <p>确定删除？</p>
                          <div>
                            <el-button size="small" type="default" plain
                              @click="scope.row.deleteVisible = false">取消</el-button>
                            <el-button size="small" type="primary" @click="handleDelete(scope)">确定</el-button>
                          </div>
                          <span class="text lh48 ml20" slot="reference"><el-button size="small" type="text"
                              :loading="deleteLoading">删除</el-button></span>
                        </el-popover>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
                <template v-if="tabName == '2'">
                  <!-- 子代理排行 -->
                  <el-table size="small" :data="tableData">
                    <el-table-column label="昵称">
                      <template slot-scope="scope">
                        <p>{{ scope.row.name }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="手机号">
                      <template slot-scope="scope">
                        <p>{{ scope.row.mobile }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="销售总金额">
                      <template slot-scope="scope">
                        <p>{{ scope.row.totalConsumptionAmount }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="销售总笔数">
                      <template slot-scope="scope">
                        <p>{{ scope.row.totalConsumptionNum }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="服务订单金额">
                      <template slot-scope="scope">
                        <p>{{ scope.row.serviceOrderAmount }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="服务订单笔数">
                      <template slot-scope="scope">
                        <p>{{ scope.row.serviceOrderNum }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="商品订单金额">
                      <template slot-scope="scope">
                        <p>{{ scope.row.productOrderAmount }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="商品订单笔数">
                      <template slot-scope="scope">
                        <p>{{ scope.row.productOrderNum }}</p>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
                <template v-if="tabName == '3'">
                  <!-- 提现记录 -->
                  <el-table size="small" :data="tableData">
                    <el-table-column label="提现申请时间">
                      <template slot-scope="scope">
                        <p>{{ COMMON.formatDate('2', '-', scope.row.createDate) }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="提现金额">
                      <template slot-scope="scope">
                        <p>{{ scope.row.amount }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="提现账户">
                      <template slot-scope="scope">
                        <p>
                          <span>开户行：{{ scope.row.bank }}</span><br>
                          <span>卡号：{{ scope.row.bankCardId }}</span>
                        </p>
                      </template>
                    </el-table-column>
                    <el-table-column label="提现完成时间">
                      <template slot-scope="scope">
                        <p v-if="scope.row.status == 1">{{ COMMON.formatDate('2', '-', scope.row.lastUpdateDate) }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="状态">
                      <template slot-scope="scope">
                        <p v-if="scope.row.status == 0">处理中</p>
                        <p v-if="scope.row.status == 1">提现成功</p>
                        <p v-if="scope.row.status == 2">提现失败</p>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>

                <div class="table-footer" v-if="page.total > 0">
                  <div class="selection-operate"></div>

                  <div class="pagination-wrap">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                      :page-sizes="[20, 50, 100]" :current-page="page.current" :page-size="page.size"
                      layout="total, sizes, prev, pager, next, jumper" :total="page.total">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form>

      

    <!-- 增加分销收益 -->
    <el-dialog title="增加分销收益" :visible.sync="dialogShow" width="500px">
      <el-form size="small" ref="formDialog" :model="formDialog" label-width="100px" class="dialog-form">
        <el-form-item label="订单门店" required :show-message="false">
          <el-select v-model="formDialog.shopId" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in shopOptions" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="顾客" required :show-message="false">
          <el-select v-model="formDialog.customerId" filterable remote reserve-keyword placeholder="请输入姓名或手机号搜索"
            :remote-method="handleCustomerSearch" :loading="customerListLoading" style="width: 100%;"
            @visible-change="handleCustomerSelectVisible">
            <el-option v-for="item in customerOptions" :key="item.id"
              :label="item.name + (item.mobile ? ' (' + item.mobile + ')' : '')" :value="item.id"></el-option>
          </el-select>
          <p class="tips" style="margin-top: 5px;" v-if="customerPage.total > 0">共找到 {{ customerPage.total }} 位顾客</p>
        </el-form-item>
        <el-form-item label="项目" required :show-message="false">
          <el-select v-model="formDialog.serviceIds" multiple filterable placeholder="请选择项目（可多选）"
            :loading="serviceListLoading" @change="handleServiceChange" style="width: 100%;">
            <el-option v-for="item in serviceOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目明细" v-if="formDialog.serviceItems && formDialog.serviceItems.length > 0">
          <el-table :data="formDialog.serviceItems" size="small" border style="width: 100%;">
            <el-table-column label="项目名称" prop="serviceName" width="200"></el-table-column>
            <el-table-column label="实际金额" width="150">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.actualAmount" type="number" :min="0" placeholder="请输入实际金额"
                  @input="handleServiceItemAmountChange(scope.$index)" size="small">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="分销收益" width="150">
              <template slot-scope="scope">
                <el-input v-model="scope.row.income" disabled placeholder="系统自行计算" size="small">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleRemoveServiceItem(scope.$index)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="顾客账单">
          <div class="pics-box">
            <el-upload :action="uploadPicUrl" list-type="picture-card" :file-list="orderVoucherPicList"
              accept=".png,.jpg,.jpeg" :on-preview="handleVoucherPicturesPreview"
              :on-remove="handleVoucherPicturesRemove" :on-success="handleVoucherPicturesSuccess"
              :on-error="handleVoucherPicturesError" :before-upload="handleVoucherPicturesBeforeUpload" :limit="10">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
          <p class="tips">支持JPG、PNG格式，最多上传10张</p>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" plain @click="dialogShow = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleAddServiceSave" :loading="dialogLoading">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 图片预览 -->
    <el-dialog :visible.sync="previewDialogShow" custom-class="preview-image-dialog">
      <img width="100%" :src="previewDialogImageUrl" alt="">
    </el-dialog>
      </section>
</template>

<script>
import {
  COMMON,
  BASE,
  agentCompanyDetail,
  agentIncome,
  agentServiceOrderStatics,
  agentProductOrderStatics,
  agentOrderList,
  distributorSalesRank,
  agentCompanyDetailEmployeeList,
  agentCustomerListRank,
  agentChildAgents,
  agentCompanyDetailWithdrawalList,
  agentCustomerList,
  agentServiceList,
  agentSaveServiceIncome,
  agentDistributorRemoveIncome,
  userServiceLevel,
  serviceShopList
} from '@/common/api';

export default {
  data() {
    return {
      COMMON,

      id: this.$route.query.id || '',

      pageLoading: true, // 页面loading
      detail: {}, // 详情

      tabName: '1',
      subTabName: '1',

      tableData: [],
      tableLoading: false,
      page: { // 分页参数
        current: 1,
        size: 20,
        total: 0
      },

      statistics: {
        validBalance: 0,
        frozenBalance: 0,
        withdrawBalance: 0,
        serviceOrderAmount: 0,
        serviceOrderNum: 0,
        serviceOrderIncome: 0,
        productOrderAmount: 0,
        productOrderNum: 0,
        productOrderIncome: 0
      },

      dialogShow: false,
      dialogLoading: false,
      formDialog: {
        shopId: '',
        customerId: '',
        serviceIds: [], // 选中的项目ID数组
        serviceItems: [] // 项目明细数组，包含 {serviceId, serviceName, actualAmount, income}
      },
      shopOptions: [],
      customerOptions: [],
      customerListLoading: false,
      customerPage: {
        current: 1,
        size: 20,
        total: 0,
        pages: 0
      },
      customerKeyword: '',
      customerSearchTimer: null,
      customerHasMore: false,
      serviceOptions: [],
      serviceListLoading: false,
      orderVoucherPicList: [],
      uploadPicUrl: BASE + '/commodity/uploadPic', // 图片上传地址
      previewDialogShow: false,
      previewDialogImageUrl: '',
      servicePercentage: 0, // 服务等级百分比

      deleteLoading: false,

      operatePermission: COMMON.getPermissionStatus(10006) // 用户编辑权限
    }
  },
  methods: {
    /**
     * [getDetail description] 获取详情
     * @return {[type]} [description]
     */
    getDetail: function () {
      let params = {
        id: this.id
      }

      agentCompanyDetail(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.detail = data;
          this.pageLoading = false;
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleTabsChange description] 切换选项卡
     * @param  {[type]} tab   [description] 取name值用tab.name
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    handleTabsChange: function (tab, event) {
      this.page.current = 1;
      this.tableData = [];
      this.getList();
    },
    /**
     * [getList description] 获取 tab 列表数据
     * @return {[type]} [description]
     */
    getList: function () {
      if (this.tabName == '1') {
        // 分销收益
        if (this.subTabName == '1') {
          // 服务订单
          this.getOrderList(2)
        } else if (this.subTabName == '2') {
          // 商品订单
          this.getOrderList(1)
        }
      } else if (this.tabName == '2') {
        // 子代理排行
        this.getChildAgentRankList()
      } else if (this.tabName == '3') {
        // 提现记录
        this.getWithdrawalList()
      }
    },
    /**
     * [getAgentIncome description] 分销收益统计
     * @return {[type]} [description]
     */
    getAgentIncome: function () {
      let params = {
        companyId: this.id
      }

      agentIncome(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          const { validBalance, frozenBalance, withdrawBalance } = data
          Object.assign(this.statistics, {
            validBalance,
            frozenBalance,
            withdrawBalance
          })
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getServiceOrderStatics description] 服务订单统计
     * @return {[type]} [description]
     */
    getServiceOrderStatics: function () {
      let params = {
        companyId: this.id
      }

      agentServiceOrderStatics(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          const { serviceOrderAmount, serviceOrderNum, serviceOrderIncome } = data
          Object.assign(this.statistics, {
            serviceOrderAmount,
            serviceOrderNum,
            serviceOrderIncome
          })
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getProductOrderStatics description] 商品订单统计
     * @return {[type]} [description]
     */
    getProductOrderStatics: function () {
      let params = {
        companyId: this.id
      }

      agentProductOrderStatics(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          const { productOrderAmount, productOrderNum, productOrderIncome } = data
          Object.assign(this.statistics, {
            productOrderAmount,
            productOrderNum,
            productOrderIncome
          })
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getOrderList description] 服务、商品订单列表
     * @return {[type]} [description]
     */
    getOrderList: function (type) {
      this.tableLoading = true;

      let params = {
        companyId: this.id,
        pageNo: this.page.current,
        type,
        pageSize: this.page.size
      }

      agentOrderList(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.tableData = data.records || [];
          this.tableLoading = false;
          this.page.total = data.total;
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getAgentRankList description] 员工排行
     * @return {[type]} [description]
     */
    getAgentRankList: function () {
      this.tableLoading = true;

      let params = {
        companyId: this.id,
        pageNo: this.page.current,
        pageSize: this.page.size
      }

      distributorSalesRank(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.tableData = data.data.records || [];
          this.tableLoading = false;
          this.page.total = data.data.total;
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getAgentList description] 员工
     * @return {[type]} [description]
     */
    getAgentList: function () {
      this.tableLoading = true;

      let params = {
        id: this.id,
        current: this.page.current,
        size: this.page.size
      }

      agentCompanyDetailEmployeeList(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.tableData = data.records || [];
          this.tableLoading = false;
          this.page.total = data.total;
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getChildAgentRankList description] 子代理排行
     * @return {[type]} [description]
     */
    getChildAgentRankList: function () {
      this.tableLoading = true;

      let params = {
        companyId: this.id,
        pageNo: this.page.current,
        pageSize: this.page.size
      }

      agentCustomerListRank(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.tableData = data.records || [];
          this.tableLoading = false;
          this.page.total = data.total;
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getChildAgentList description] 子代理
     * @return {[type]} [description]
     */
    getChildAgentList: function () {
      this.tableLoading = true;

      let params = {
        id: this.id,
        current: this.page.current,
        size: this.page.size
      }

      agentChildAgents(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.tableData = data.records || [];
          this.tableLoading = false;
          this.page.total = data.total;
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getWithdrawalList description] 提现记录
     * @return {[type]} [description]
     */
    getWithdrawalList: function () {
      this.tableLoading = true;

      let params = {
        companyId: this.id,
        current: this.page.current,
        size: this.page.size
      }

      agentCompanyDetailWithdrawalList(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.tableData = data.records || [];
          this.tableLoading = false;
          this.page.total = data.total;
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.current = 1;
      this.page.size = val;

      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择分页第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;

      this.getList();
    },
    /**
     * [handleAddServiceDialogShow description] 增加分销收益 - 弹窗 - 显示
     * @return {[type]}          [description]
     */
    handleAddServiceDialogShow() {
      this.dialogLoading = false;
      Object.assign(this.formDialog, {
        shopId: '',
        customerId: '',
        serviceIds: [],
        serviceItems: []
      })
      this.orderVoucherPicList = [];
      // 重置顾客搜索相关数据
      this.customerOptions = [];
      this.customerKeyword = '';
      this.customerPage.current = 1;
      this.dialogShow = true;
      // 获取项目列表
      this.getServiceList();
    },
    /**
     * [getCustomerList description] 获取顾客列表（支持分页和搜索）
     * @param  {[type]} page [description] 页码，默认为1
     * @param  {[type]} keyword [description] 搜索关键词
     * @param  {[type]} append [description] 是否追加数据
     * @return {[type]} [description]
     */
    getCustomerList: function (page = 1, keyword = '', append = false) {
      this.customerListLoading = true;
      let params = {
        current: page,
        size: this.customerPage.size
      }
      if (keyword) {
        params.keyword = keyword;
      }

      agentCustomerList(params).then(res => {
        this.customerListLoading = false;
        let { code, data, msg } = res;
        if (code == 0 || code == '200') {
          if (append) {
            // 追加数据
            this.customerOptions = this.customerOptions.concat(data.records || []);
          } else {
            // 替换数据
            this.customerOptions = data.records || [];
          }
          // 更新分页信息
          this.customerPage = {
            current: data.current || page,
            size: data.size || this.customerPage.size,
            total: data.total || 0,
            pages: data.pages || 0
          }
          // 判断是否还有更多数据
          this.customerHasMore = this.customerPage.current < this.customerPage.pages;
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.customerListLoading = false;
        this.$message.error('获取顾客列表失败');
      });
    },
    /**
     * [handleCustomerSearch description] 顾客搜索（带防抖）
     * @param  {[type]} keyword [description] 搜索关键词
     * @return {[type]} [description]
     */
    handleCustomerSearch: function (keyword) {
      // 清除之前的定时器
      if (this.customerSearchTimer) {
        clearTimeout(this.customerSearchTimer);
      }

      this.customerKeyword = keyword;

      // 防抖处理，500ms后执行搜索
      this.customerSearchTimer = setTimeout(() => {
        this.customerPage.current = 1;
        this.getCustomerList(1, keyword, false);
      }, 500);
    },
    /**
     * [handleCustomerSelectVisible description] 顾客下拉框显示/隐藏
     * @param  {[type]} visible [description]
     * @return {[type]} [description]
     */
    handleCustomerSelectVisible: function (visible) {
      if (visible) {
        // 下拉框打开时，如果没有数据则加载第一页
        if (this.customerOptions.length === 0 && !this.customerListLoading) {
          this.getCustomerList(1, '', false);
        }
      }
    },
    /**
     * [getServiceList description] 获取项目/服务列表
     * @return {[type]} [description]
     */
    getServiceList: function (name) {
      this.serviceListLoading = true;
      let params = {};
      if (name) {
        params.name = name;
      }
      agentServiceList(params).then(res => {
        this.serviceListLoading = false;
        let { code, data, msg } = res;
        if (code == 0 || code == '200') {
          this.serviceOptions = data || [];
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.serviceListLoading = false;
        this.$message.error('获取项目列表失败');
      });
      serviceShopList().then(res => {
        this.shopOptions = res.data.records;
      }).catch(error => {
        this.$message.error('获取门店列表失败');
      });
    },
    /**
     * [calculateDistributionIncome description] 计算单个项目的分销收益
     * @param  {Number} index 项目在serviceItems数组中的索引
     * @return {[type]} [description]
     */
    calculateDistributionIncome: function (index) {
      if (index === undefined || !this.formDialog.serviceItems || !this.formDialog.serviceItems[index]) {
        return;
      }

      const item = this.formDialog.serviceItems[index];
      const actualAmount = parseFloat(item.actualAmount);

      if (!isNaN(actualAmount) && actualAmount > 0 && this.servicePercentage > 0) {
        // 分销收益 = 实际金额 * (servicePercentage / 100)
        const percentage = this.servicePercentage / 100;
        const income = (actualAmount * percentage).toFixed(2);
        this.$set(item, 'income', income);
      } else {
        this.$set(item, 'income', '');
      }
    },
    /**
     * [handleServiceChange description] 选择项目后，更新serviceItems数组
     * @return {[type]} [description]
     */
    handleServiceChange: function () {
      const selectedIds = this.formDialog.serviceIds || [];
      const currentItems = this.formDialog.serviceItems || [];

      // 找出新增的项目ID
      const newIds = selectedIds.filter(id => !currentItems.find(item => item.serviceId == id));

      // 找出需要删除的项目（已取消选择的）
      const itemsToKeep = currentItems.filter(item => selectedIds.includes(item.serviceId));

      // 为新增的项目创建项目明细
      const newItems = newIds.map(serviceId => {
        const service = this.serviceOptions.find(item => item.id == serviceId);
        return {
          serviceId: serviceId,
          serviceName: service ? service.name : '',
          actualAmount: service && service.price ? service.price : '',
          income: ''
        };
      });

      // 更新serviceItems数组
      this.formDialog.serviceItems = [...itemsToKeep, ...newItems];

      // 为新增的项目计算分销收益
      newItems.forEach((item, index) => {
        const actualIndex = itemsToKeep.length + index;
        if (item.actualAmount) {
          this.calculateDistributionIncome(actualIndex);
        }
      });
    },
    /**
     * [handleServiceItemAmountChange description] 项目明细中实际金额变化时，自动计算分销收益
     * @param  {Number} index 项目在serviceItems数组中的索引
     * @return {[type]} [description]
     */
    handleServiceItemAmountChange: function (index) {
      this.calculateDistributionIncome(index);
    },
    /**
     * [handleRemoveServiceItem description] 删除项目明细
     * @param  {Number} index 项目在serviceItems数组中的索引
     * @return {[type]} [description]
     */
    handleRemoveServiceItem: function (index) {
      const item = this.formDialog.serviceItems[index];
      if (item) {
        // 从serviceIds中移除对应的ID
        this.formDialog.serviceIds = this.formDialog.serviceIds.filter(id => id != item.serviceId);
        // 从serviceItems中移除
        this.formDialog.serviceItems.splice(index, 1);
      }
    },
    /**
     * [handleAddServiceSave description] 增加分销收益 - 弹窗 - 保存
     * @return {[type]}          [description]
     */
    handleAddServiceSave: function () {
      if (!this.formDialog.shopId) {
        this.$message.error('请选择订单门店');
        return false;
      }
      if (!this.formDialog.customerId) {
        this.$message.error('请选择顾客');
        return false;
      }
      if (!this.formDialog.serviceItems || this.formDialog.serviceItems.length === 0) {
        this.$message.error('请至少选择一个项目');
        return false;
      }

      // 验证每个项目的实际金额和分销收益
      for (let i = 0; i < this.formDialog.serviceItems.length; i++) {
        const item = this.formDialog.serviceItems[i];
        const actualAmount = parseFloat(item.actualAmount);
        const income = parseFloat(item.income);

        if (!actualAmount || actualAmount <= 0) {
          this.$message.error(`项目"${item.serviceName || '未知'}"的实际金额必须大于0`);
          return false;
        }
        if (!income || income <= 0) {
          this.$message.error(`项目"${item.serviceName || '未知'}"的分销收益必须大于0`);
          return false;
        }
      }

      // this.dialogLoading = true;

      // 获取订单凭证图片URL列表
      const orderVoucherImages = this.orderVoucherPicList.map(item => {
        return item.response && item.response.data ? item.response.data.path : item.url;
      }).filter(url => url);

      // 构建serviceItems数组
      const serviceItems = this.formDialog.serviceItems.map(item => {
        return {
          serviceId: item.serviceId,
          actualAmount: parseFloat(item.actualAmount),
          income: parseFloat(item.income),
          serviceName: item.serviceName || ''
        };
      });

      let param = {
        companyId: this.id,
        customerId: this.formDialog.customerId,
        serviceItems: serviceItems,
        orderVoucherImages: orderVoucherImages,
        shopId: this.formDialog.shopId
      }
      agentSaveServiceIncome(param).then(res => {
        this.dialogLoading = false;

        let { code, data, msg } = res;

        if (code == 0 || code == '200') {
          this.$message.success('增加分销收益成功');
          this.dialogShow = false;
          this.getList();
          this.getServiceOrderStatics();
          this.getAgentIncome();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
        this.dialogLoading = false;
      })
    },
    /**
     * [handleVoucherPicturesBeforeUpload description] 订单凭证图片上传之前
     * @param  {[type]} file [description]
     * @return {[type]}      [description]
     */
    handleVoucherPicturesBeforeUpload: function (file) {
      let fileName = file.name,
        fileNameArr = fileName.split('.'),
        fileType = fileNameArr[fileNameArr.length - 1],
        supportArr = ['jpg', 'jpeg', 'png'];

      if (supportArr.indexOf(fileType.toLowerCase()) == -1) {
        this.$message.error('请上传JPG、PNG格式的图片');
        return false;
      }
    },
    /**
     * [handleVoucherPicturesSuccess description] 订单凭证图片上传成功
     * @param  {[type]} response [description]
     * @param  {[type]} file     [description]
     * @param  {[type]} fileList [description]
     * @return {[type]}          [description]
     */
    handleVoucherPicturesSuccess: function (response, file, fileList) {
      console.log('图片上传响应:', response);
      console.log('文件对象:', file);
      console.log('文件列表:', fileList);

      if (response && (response.code == 0 || response.code == '200')) {
        // 使用默认的本地临时地址预览
        this.orderVoucherPicList = fileList;

        // // 以下代码为设置网络地址预览，如需使用请取消注释
        // let imageUrl = '';
        // if (response.data) {
        //   if (response.data.url) {
        //     imageUrl = response.data.url;
        //   } else if (response.data.path) {
        //     imageUrl = response.data.path;
        //   }
        // }
        // if (imageUrl) {
        //   // 设置当前文件的 url（el-upload 需要这个来显示缩略图）
        //   this.$set(file, 'url', imageUrl);
        //   // 同时更新 fileList 中对应文件的 url
        //   const currentFileIndex = fileList.findIndex(item => item.uid === file.uid);
        //   if (currentFileIndex > -1) {
        //     this.$set(fileList[currentFileIndex], 'url', imageUrl);
        //   }
        // } else {
        //   console.warn('无法从响应中获取图片URL，响应数据:', response);
        // }
        // this.orderVoucherPicList = fileList;
      } else {
        this.$message.error(response && response.msg ? response.msg : '图片上传失败');
        // 移除上传失败的文件
        const index = fileList.findIndex(item => item.uid === file.uid);
        if (index > -1) {
          fileList.splice(index, 1);
        }
        this.orderVoucherPicList = fileList;
      }
    },
    /**
     * [handleVoucherPicturesError description] 订单凭证图片上传失败
     * @param  {[type]} err      [description]
     * @param  {[type]} file     [description]
     * @param  {[type]} fileList [description]
     * @return {[type]}          [description]
     */
    handleVoucherPicturesError: function (err, file, fileList) {
      this.$message.error('图片上传失败');
      this.orderVoucherPicList = fileList;
    },
    /**
     * [handleVoucherPicturesRemove description] 订单凭证图片删除
     * @param  {[type]} file     [description]
     * @param  {[type]} fileList [description]
     * @return {[type]}          [description]
     */
    handleVoucherPicturesRemove: function (file, fileList) {
      this.orderVoucherPicList = fileList;
    },
    /**
     * [handleVoucherPicturesPreview description] 订单凭证图片预览
     * @param  {[type]} file [description]
     * @return {[type]}      [description]
     */
    handleVoucherPicturesPreview: function (file) {
      // 获取图片URL
      let imageUrl = file.url || '';

      // 如果 file.url 不存在，从 response 中获取
      if (!imageUrl && file.response) {
        if (file.response.data) {
          imageUrl = file.response.data.path || file.response.data.url || '';
        } else if (file.response.url) {
          imageUrl = file.response.url;
        }
      }

      // 如果还是没有，从 fileList 中查找对应的文件
      if (!imageUrl) {
        const fileItem = this.orderVoucherPicList.find(item => item.uid === file.uid);
        if (fileItem) {
          imageUrl = fileItem.url || '';
          if (!imageUrl && fileItem.response && fileItem.response.data) {
            imageUrl = fileItem.response.data.url || fileItem.response.data.path || '';
          }
        }
      }

      if (imageUrl) {
        this.previewDialogImageUrl = imageUrl;
        this.previewDialogShow = true;
      } else {
        console.log('预览文件对象:', file);
        console.log('文件列表:', this.orderVoucherPicList);
        this.$message.warning('无法获取图片地址，请检查图片是否上传成功');
      }
    },
    /**
     * [handleDelete description] 删除角色
     * @param  {[Object]} scope [description] 操作行的对象
     * @return {[type]}     [description]
     */
    handleDelete: function (scope) {
      this.deleteLoading = true;

      agentDistributorRemoveIncome({ 'incomeId': scope.row.incomeId }).then(res => {
        this.deleteLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.$message.success('删除成功');
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.deleteLoading = false;
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getUserServiceLevel description] 获取用户服务等级信息
     * @return {[type]} [description]
     */
    getUserServiceLevel: function () {
      console.log('=== 获取用户服务等级信息 ===');
      console.log('代理商ID:', this.id);

      let params = {
        agentId: this.id
      }

      userServiceLevel(params).then(res => {
        console.log('服务等级接口响应:', res);
        let { code, data, message } = res;

        if (code == 0 || code == '200') {
          console.log('接口调用成功，返回数据:', data);
          if (data && data.servicePercentage) {
            console.log('设置 servicePercentage:', data.servicePercentage);
            this.servicePercentage = data.servicePercentage;
            console.log('当前 servicePercentage 值:', this.servicePercentage);
          } else {
            console.warn('返回数据中没有 servicePercentage 字段');
          }
        } else {
          console.warn('获取服务等级信息失败:', message || '未知错误');
          console.warn('返回码:', code);
        }
      }).catch(error => {
        console.error('获取服务等级信息异常:', error);
      });
    }
  },
  mounted: function () {
    console.log('=== 页面加载 ===');
    console.log('用户ID:', this.id);
    this.getDetail();
    this.getList();
    this.getAgentIncome()
    this.getServiceOrderStatics()
    this.getProductOrderStatics()
    console.log('调用 getUserServiceLevel');
    this.getUserServiceLevel()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../common/styles/base/_mixin-font';
@import "../../../common/styles/base/mixin-common";

.statistics {
  margin-top: -10px;
  padding: 10px;
  background: #EFFAFF;
  border-radius: 4px;
  font-size: 0;

  &.default {
    border: 1px solid #D9D9D9;
    background: transparent;
  }

  .item {
    font-size: 12px;
    color: #222222;
    letter-spacing: 0;
    font-weight: 600;

    &+.item {
      margin-left: 80px;
    }
  }
}

.no-margin-top {
  margin-top: 0;
}

.mr-10 {
  margin-right: 10px;
}

.mr-20 {
  margin-right: 20px;
}

.pt-pb-10 {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.item-tab-body {
  margin: 10px 0;
  font-size: $smallFS;

  div {
    position: relative;
    display: inline-block;
    padding: 10px 30px;
    cursor: pointer;

    &.current {
      color: $themeColor;

      &:after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 3px;
        background: $themeColor;
        z-index: 1;
      }
    }
  }
}

.order-list-item {

  &.only-bottom-border {
    border: none;
    border-bottom: 1px solid $separateDefaultColor !important;
  }

  .customTableDropDownListBackgroundColor {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 10px 5px;
    background-color: $customTableDropDownListBackgroundColor;
  }

  .overdue {
    opacity: .5;
    filter: alpha(opacity=50);
  }

  .item-body-body {
    margin: 0 10px;

    &.no-margin {
      margin: 0;
    }

    .item-body-body-header {
      background-color: $colorTitleBg;
    }

    .item-body-body-body {
      padding: 10px 0;
    }
  }
}

.module-body {
  .text {
    font-size: $smallFS;
    color: $textColor;
    line-height: 27px;
  }

  .avatar {
    position: relative;
    float: left;
    width: 150px;
    height: 150px;
    margin-left: 10px;
    /*background: $colorImgBg;*/

    img {
      max-width: 100%;
      max-height: 100%;
      @include position(absolute, 1, 50%, none, none, 50%);
      @include translate(-50%, -50%, 0);
    }
  }

  .info {
    float: left;
    margin-left: 10px;
  }

  .personal-info-box {
    margin-bottom: 40px;

    .personal-info {
      float: left;
      margin-left: 10px;
    }

    .personal-avatar-info {
      float: left;
      margin-left: 40px;

      .personal-avatar {
        position: relative;
        margin-top: 5px;
        width: 200px;
        height: 130px;
        background: $colorImgBg;

        img {
          max-width: 100%;
          max-height: 100%;
          @include position(absolute, 1, 50%, none, none, 50%);
          @include translate(-50%, -50%, 0);
        }
      }
    }

    .personal-first-avatar-info {
      float: left;
      margin-left: 40px;

      .personal-first-avatar {
        position: relative;
        margin-top: 5px;
        width: 200px;
        height: 130px;
        background: $colorImgBg;

        img {
          max-width: 100%;
          max-height: 100%;
          @include position(absolute, 1, 50%, none, none, 50%);
          @include translate(-50%, -50%, 0);
        }
      }
    }
  }
}

.dialog-photo-past {
  position: relative;
  margin: 0 auto;
  padding: 10px 0;

  p {
    margin-bottom: 20px;
    text-align: center;
  }

  .pic-list {
    position: relative;
    margin: 0 auto;
    width: 420px;
    height: 130px;

    .pic-item {
      position: relative;
      width: 110px;
      height: 130px;
      margin: 0 15px;
      background: $colorImgBg;

      img {
        @include position(absolute, 3, 50%, none, none, 50%);
        max-width: 100%;
        max-height: 100%;
        @include translate(-50%, -50%, 0);
      }
    }
  }

  .left-icon,
  .right-icon {
    position: absolute;
    z-index: 5;
    top: 50%;
    margin-top: -20px;
    font-size: 34px;
    color: $swiperArrowColor;
    cursor: pointer;

    &:hover {
      color: $darkButtonBackgroundHoverColor;
    }

    &[disabled="disabled"] {
      opacity: .3;
      cursor: not-allowed;
    }
  }

  .left-icon {
    left: 0;
  }

  .right-icon {
    right: 0;
  }
}

.pics-box {
  ::v-deep .el-upload-list--picture-card {
    .el-upload-list__item {
      position: relative;
      width: 100px;
      height: 100px;
      border-radius: 2px;
      transition: none;

      .el-upload-list__item-thumbnail {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 98px;
    border-radius: 2px;

    .el-upload-dragger {
      width: 98px;
      height: 98px;
      border: none;

      .el-icon-plus {
        font-size: 12px;
      }
    }
  }
}

.tips {
  margin-top: 5px;
  font-size: 12px;
  color: #999;
}
</style>
